import React from 'react'
import { formDataToObject } from '../utilities'
import useFormHooks from '../Hooks/useFormHooks'
const PageForm = () => {
  const { POST } = useFormHooks()
  const handleSubmit = async e => {
    e.preventDefault()
    const formData = new FormData(e.target)

    try {
      await POST('/wp-json/wp/v2/email-subscriptions', {
        title: `new subscriber - ${formDataToObject(formData)?.first_name} ${
          formDataToObject(formData)?.last_name
        }`,
        acf: {
          email: formDataToObject(formData)?.email,
          first_name: formDataToObject(formData)?.first_name,
          last_name: formDataToObject(formData)?.last_name,
          opt_in: formDataToObject(formData)?.opt_in
        }
      }).then(data => {
        e.target.reset()
      })
    } catch (error) {}
  }

  return (
    <form onSubmit={handleSubmit} className='form-wrapper relative z-10'>
      <div className='flex gap-2 w-full justify-between'>
        <label className='input-field'>
          <input
            type='text'
            name='first_name'
            placeholder='Enter your first name here.'
            required
          />
          <span className='label-text'>First Name</span>
        </label>
        <label className='input-field'>
          <input
            type='text'
            name='last_name'
            placeholder='Enter your last name here.'
            required
          />
          <span className='label-text'>Last Name</span>
        </label>
      </div>
      <div className='flex gap-2 w-full justify-between'>
        <label className='input-field'>
          <input
            type='email'
            name='email'
            required
            placeholder='Enter your e-mail address.'
          />
          <span className='label-text'>Email</span>
        </label>
        <label className='input-field flex-row-reverse justify-between items-center'>
          <p className=''>I would like to recieve emails</p>
          <input className='' type='checkbox' name='opt_in' required />
          <span className='checkbox-circle'></span>
        </label>
      </div>

      <button className='btn' type='submit'>
        Submit
      </button>
    </form>
  )
}

export default PageForm
